(function () {
  /* ====== CẤU HÌNH ====== */
  var TEXT = {
    launcher: 'Dina förmåner',
    title: 'Dina exklusiva erbjudanden',
    subtitle: 'Gör mer av ditt köp med våra utvalda gåvor',
    button: 'Säkra din gåva',
    close: 'Stäng',
    currency: 'kr',
    moreGifts: '+{{count}}',
    conditionAmount: 'Vid köp{{target}} för minst {{value}} {{currency}}',
    conditionQuantity: 'Vid köp{{target}}, minst {{value}} st',
    conditionAny: 'Vid varje köp{{target}}',
    target: ' av {{name}}'
  };
  // (Tuỳ chọn) Ghi đè theo rule ID, ví dụ: { '26601': 'Free Tote Bag' }
  var TITLE_BY_RULE_ID = {};
  // ví dụ: { '26601': 'Vid köp av Kevin Murphy för minst 1000 kr' }
  var DESCRIPTION_BY_RULE_ID = {};
  // ví dụ: { '26601': 'https://cdn.shopify.com/...jpg' }
  var IMAGE_BY_RULE_ID = {};
  // ví dụ: { '26601': '/collections/kevin-murphy' }
  var URL_BY_RULE_ID = {};
  // Thời gian tối đa chờ ảnh (ms)
  var IMAGE_WAIT_MS = 3000;
  // Số quà tối đa lấy cho mỗi offer (quà từ collection được tải theo trang)
  var MAX_GIFTS_PER_OFFER = 30;

  // Gift in cart: chữ số ít / số nhiều cho dòng "2 OFFERS" (so khớp không phân biệt hoa thường)
  var GIC_PLURALS = [
    { one: 'offer', other: 'offers' },
    { one: 'erbjudande', other: 'erbjudanden' }
  ];
  /* ====================== */

  if (window.__bssTodayOfferLauncher) return;
  window.__bssTodayOfferLauncher = true;

  var CSS = [
    /* Ẩn tab Today Offers gốc bên phải khi UI mới đã sẵn sàng */
    'html.bss-offer-on .tl-today-offer-widget-anchor{display:none !important;}',

    '#bss-offer-root{--bss-dark:#222;--bss-text:#1f1f1f;--bss-muted:#6b6b6b;--bss-border:#e8e8e8;--bss-red:#e8202a;',
    '  position:fixed;left:16px;bottom:16px;z-index:2147483000;font-family:inherit;display:none;}',
    '#bss-offer-root.is-ready{display:block;}',
    '#bss-offer-root *{box-sizing:border-box;}',

    /* Nút "Dina förmåner" */
    '.bss-offer-launcher{position:relative;display:flex;align-items:center;gap:10px;margin:0;padding:14px 18px;background:#fff;',
    '  border:none;border-radius:10px;box-shadow:0 4px 18px rgba(0,0,0,.16);cursor:pointer;font:inherit;',
    '  font-size:16px;font-weight:600;color:var(--bss-text);line-height:1;letter-spacing:normal;text-transform:none;}',
    '.bss-offer-launcher svg{width:26px;height:26px;flex-shrink:0;}',
    '.bss-offer-badge{position:absolute;top:-9px;right:-9px;min-width:22px;height:22px;padding:0 5px;border-radius:11px;',
    '  background:var(--bss-red);color:#fff;font-size:12px;font-weight:600;display:flex;align-items:center;justify-content:center;',
    '  border:2px solid #fff;line-height:1;}',

    /* Khung panel */
    '.bss-offer-panel{position:absolute;left:0;bottom:calc(100% + 14px);width:415px;max-width:calc(100vw - 32px);',
    '  max-height:min(560px,calc(100vh - 120px));display:flex;flex-direction:column;background:#fff;border-radius:8px;',
    '  box-shadow:0 8px 30px rgba(0,0,0,.2);overflow:hidden;',
    '  opacity:0;visibility:hidden;transform:translateY(8px);transition:opacity .2s,transform .2s,visibility .2s;}',
    '#bss-offer-root.is-open .bss-offer-panel{opacity:1;visibility:visible;transform:translateY(0);}',

    '.bss-offer-head{position:relative;flex-shrink:0;padding:16px 48px 14px 16px;background:#fff;}',
    '.bss-offer-head-title{margin:0;font-size:21px;font-weight:500;line-height:1.3;color:var(--bss-text);}',
    '.bss-offer-head-sub{margin:4px 0 0;font-size:14px;line-height:1.4;color:var(--bss-muted);}',
    '.bss-offer-close{position:absolute;top:14px;right:12px;width:28px;height:28px;padding:0;margin:0;border:none;background:none;',
    '  cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--bss-text);}',
    '.bss-offer-close svg{width:16px;height:16px;}',

    '.bss-offer-list{flex:1;min-height:0;overflow-y:auto;padding:14px;background:#f6f6f6;display:flex;flex-direction:column;gap:12px;}',
    '.bss-offer-list::-webkit-scrollbar{width:6px;}',
    '.bss-offer-list::-webkit-scrollbar-thumb{background:#c9c9c9;border-radius:3px;}',

    /* Thẻ offer */
    '.bss-offer-card{display:flex;flex-shrink:0;background:#fff;border:1px solid var(--bss-border);border-radius:10px;overflow:hidden;}',
    '.bss-offer-thumb{flex:0 0 150px;width:150px;padding:10px;border-right:1px dashed #d6d6d6;display:flex;flex-direction:column;',
    '  align-items:center;justify-content:center;gap:6px;}',
    '.bss-offer-thumb img{display:block !important;width:100% !important;height:auto !important;aspect-ratio:1/1;max-width:none !important;',
    '  object-fit:cover !important;border-radius:6px;opacity:1 !important;visibility:visible !important;position:static !important;}',
    '.bss-offer-thumb-empty{width:100%;aspect-ratio:1/1;border-radius:6px;background:#efefef;display:flex;align-items:center;justify-content:center;}',
    '.bss-offer-thumb-empty svg{width:36px;height:36px;}',
    /* Dải ảnh nhỏ khi offer có nhiều quà: bấm để đổi ảnh lớn */
    '.bss-offer-minis{display:flex;flex-wrap:wrap;justify-content:center;gap:4px;width:100%;}',
    '.bss-offer-mini{width:30px;height:30px;padding:0;margin:0;border:1px solid var(--bss-border);border-radius:4px;background:#fff;',
    '  overflow:hidden;cursor:pointer;flex-shrink:0;}',
    '.bss-offer-mini[aria-pressed="true"]{border-color:var(--bss-dark);}',
    '.bss-offer-thumb .bss-offer-mini img{width:100% !important;height:100% !important;border-radius:0;}',
    '.bss-offer-body{flex:1;min-width:0;padding:16px 14px;display:flex;flex-direction:column;justify-content:center;align-items:flex-start;text-align:left;}',
    '.bss-offer-title{margin:0 0 6px;font-size:15px;font-weight:500;line-height:1.35;color:var(--bss-text);}',
    '.bss-offer-desc{margin:0 0 12px;font-size:13px;line-height:1.45;color:var(--bss-muted);}',
    '.bss-offer-btn{display:inline-block;padding:8px 14px;background:var(--bss-dark);color:#fff !important;border:none;cursor:pointer;',
    '  border-radius:6px;font:inherit;font-size:13px;font-weight:500;line-height:1.2;text-decoration:none !important;transition:background .2s;}',
    '.bss-offer-btn:hover{background:#000;}',

    /* Skeleton khi chờ ảnh */
    '.bss-skel{background:linear-gradient(90deg,#eee 25%,#f6f6f6 37%,#eee 63%);background-size:400% 100%;',
    '  animation:bss-shimmer 1.2s ease infinite;border-radius:6px;}',
    '.bss-skel-img{width:100%;aspect-ratio:1/1;}',
    '.bss-skel-line{height:12px;width:80%;margin-bottom:8px;}',
    '.bss-skel-line--short{width:55%;}',
    '.bss-skel-btn{height:30px;width:110px;margin-top:6px;}',
    '@keyframes bss-shimmer{0%{background-position:100% 50%}100%{background-position:0 50%}}',

    '@media (max-width:640px){',
    '  .bss-offer-launcher{font-size:15px;padding:12px 16px;}',
    '  .bss-offer-launcher svg{width:22px;height:22px;}',
    '  .bss-offer-panel{max-height:calc(100vh - 140px);}',
    '  .bss-offer-head-title{font-size:18px;}',
    '  .bss-offer-head-sub{font-size:13px;}',
    '  .bss-offer-list{padding:10px;gap:10px;}',
    '  .bss-offer-thumb{flex-basis:110px;width:110px;padding:8px;}',
    '  .bss-offer-mini{width:24px;height:24px;}',
    '  .bss-offer-body{padding:12px;}',
    '  .bss-offer-title{font-size:14px;}',
    '  .bss-offer-desc{font-size:12px;margin-bottom:10px;}',
    '}'
  ].join('\n');

  var giftSvg =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path fill="#e8202a" d="M3 10h18v3H3zM4 13h7v9H4zM13 13h7v9h-7z"/>' +
      '<path fill="#e8202a" d="M11 10h2v12h-2z" opacity=".55"/>' +
      '<path fill="none" stroke="#e8202a" stroke-width="2" d="M12 10C10 6 6 5 6 7.5S10 10 12 10zm0 0c2-4 6-5 6-2.5S14 10 12 10z"/>' +
    '</svg>';
  var tagSvg =
    '<svg viewBox="0 0 24 24" fill="none" stroke="#9a9a9a" stroke-width="1.6" aria-hidden="true">' +
      '<path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9z"/><circle cx="7.5" cy="7.5" r="1.5"/>' +
    '</svg>';
  var closeSvg =
    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">' +
      '<path d="M3 3l10 10M13 3L3 13"/>' +
    '</svg>';

  function injectStyle() {
    if (document.getElementById('bss-today-offer-style')) return;
    var style = document.createElement('style');
    style.id = 'bss-today-offer-style';
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fill(template, values) {
    return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      return values[key] == null ? '' : String(values[key]);
    });
  }

  function call(fn, self, args, fallback) {
    try { return typeof fn === 'function' ? fn.apply(self, args) : fallback; } catch (e) { return fallback; }
  }

  function imgSrc(v) {
    if (!v) return '';
    if (typeof v === 'string') return v;
    return v.src || v.url || v.originalSrc || '';
  }

  function normalizeUrl(u) {
    if (!u) return '';
    return u.indexOf('//') === 0 ? 'https:' + u : u;
  }

  function getWidget() {
    return window.SalepifyTodayOffer && window.SalepifyTodayOffer.widget;
  }

  function getFetched(module, rule) {
    return call(module.getFetchedGiftResources, module, [rule.id], []) || [];
  }

  function getHandle(gift) {
    return gift.handle || (gift.product && gift.product.handle) || '';
  }

  function giftKey(module, gift) {
    return String(call(module.getResourceId, module, [gift], '') || gift.shopify_id || gift.id || gift.handle || '');
  }

  function uniqueGifts(module, gifts) {
    var seen = {};
    return gifts.filter(function (g) {
      var k = giftKey(module, g) || getHandle(g);
      if (!k || seen[k]) return false;
      seen[k] = true;
      return true;
    });
  }

  // Quà từ collection: tải tiếp từng trang bằng chính hàm của app cho tới khi đủ
  function loadCollectionGifts(module, rule, acc, page) {
    acc = uniqueGifts(module, acc.concat(getFetched(module, rule)));
    var status = call(module.getResourceFetchStatus, module, [rule.id], {}) || {};
    if (status.is_complete_fetching || page >= 10 || acc.length >= MAX_GIFTS_PER_OFFER) return Promise.resolve(acc);
    return Promise.resolve(call(module.fetchResourcesWithState, module, [rule], [])).then(function (next) {
      var merged = uniqueGifts(module, acc.concat(next || [], getFetched(module, rule)));
      if (merged.length <= acc.length) return merged;
      return loadCollectionGifts(module, rule, merged, page + 1);
    }, function () { return acc; });
  }

  // Toàn bộ quà đã cấu hình trong offer
  function getRuleGifts(module, rule) {
    var constants = window.tlFreeGiftOffer && window.tlFreeGiftOffer.constants;
    var collectionType = (constants && constants.GIFT_TYPE && constants.GIFT_TYPE.COLLECTION) || 'collection';
    if (rule.gift_type === collectionType) {
      return loadCollectionGifts(module, rule, [], 0).then(function (list) { return list.slice(0, MAX_GIFTS_PER_OFFER); });
    }
    // Quà là product / variant: listChilds chứa đủ danh sách, ghép với dữ liệu app đã tải (nếu có)
    var configs = call(module.getDisplayGiftConfigs, module, [rule], null) || rule.listChilds || [];
    var fetched = getFetched(module, rule);
    var list = configs.map(function (c) {
      var id = String(c.shopify_id || c.id || '');
      for (var i = 0; i < fetched.length; i++) {
        if ((id && giftKey(module, fetched[i]) === id) || (c.handle && getHandle(fetched[i]) === c.handle)) {
          return Object.assign({}, c, fetched[i]);
        }
      }
      return c;
    });
    return Promise.resolve(uniqueGifts(module, list.length ? list : fetched).slice(0, MAX_GIFTS_PER_OFFER));
  }

  // Ảnh có sẵn trong dữ liệu quà (variant / product)
  function getDataImage(module, gift) {
    var p = gift.product || {};
    return call(module.getResourceImage, module, [gift], '')
      || imgSrc(gift.featured_image) || imgSrc(gift.featuredImage) || imgSrc(gift.image)
      || imgSrc(p.featured_image) || imgSrc(p.featuredImage) || imgSrc(p.image)
      || imgSrc(p.images && p.images[0]) || imgSrc(p.images && p.images.nodes && p.images.nodes[0])
      || '';
  }

  // /products/<handle>.js -> { title, featured_image, variants } (có cache)
  var productCache = {};
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  var imageCache = {};
  function preloadImage(src) {
    if (!src) return Promise.resolve();
    if (!imageCache[src]) {
      imageCache[src] = new Promise(function (resolve) {
        var img = new Image();
        img.onload = img.onerror = function () { resolve(); };
        img.src = src;
        setTimeout(resolve, IMAGE_WAIT_MS);
      });
    }
    return imageCache[src];
  }

  // Tên + ảnh của 1 quà: dữ liệu app -> /products/<handle>.js (ảnh của đúng variant nếu có)
  function resolveGift(module, ctx, gift) {
    var title = call(module.getResourceTitle, module, [ctx, gift], '') || gift.title || '';
    var image = normalizeUrl(getDataImage(module, gift));
    var handle = getHandle(gift);
    var needProduct = handle && (!image || !title);

    return (needProduct ? fetchProduct(handle) : Promise.resolve(null)).then(function (p) {
      if (p) {
        var variantId = String(gift.shopify_id || gift.variant_id || '').split('/').pop();
        var variant = (p.variants || []).filter(function (v) { return String(v.id) === variantId; })[0];
        if (!title) title = p.title + (variant && variant.title && variant.title !== 'Default Title' ? ' - ' + variant.title : '');
        if (!image) image = normalizeUrl((variant && variant.featured_image && variant.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '');
      }
      return preloadImage(image).then(function () { return { title: title, image: image }; });
    });
  }

  // Mô tả: ghi đè -> subtitle tuỳ chỉnh trong app -> tự tạo từ điều kiện
  function buildDescription(widget, rule) {
    if (DESCRIPTION_BY_RULE_ID[rule.id]) return DESCRIPTION_BY_RULE_ID[rule.id];
    var tr = (widget.translations && widget.translations[rule.id]) || {};
    var custom = rule.custom_subtitle || tr.subtitle;
    if (custom) return custom;

    var parent = (rule.listParents || [])[0] || {};
    var parentName = rule.apply_to_product === 'all' ? '' : (parent.title || parent.name || '');
    var values = {
      target: parentName ? fill(TEXT.target, { name: parentName }) : '',
      value: Number(rule.apply_condition_value) || 0,
      currency: TEXT.currency
    };
    if (!values.value) return fill(TEXT.conditionAny, values);
    return fill(rule.apply_condition_type === 'amount' ? TEXT.conditionAmount : TEXT.conditionQuantity, values);
  }

  // Tên thẻ khi chưa ghi đè: "Quà A" / "Quà A + Quà B" / "Quà A + Quà B +3"
  function joinGiftTitles(titles) {
    titles = titles.filter(Boolean);
    var shown = titles.slice(0, 2).join(' + ');
    return titles.length > 2 ? shown + ' ' + fill(TEXT.moreGifts, { count: titles.length - 2 }) : shown;
  }

  // Mỗi offer là 1 thẻ, chứa toàn bộ quà của offer đó
  function getOfferCard(widget, rule) {
    var module = call(widget.getModule, widget, [rule], null) || {};
    var ctx = call(widget.createModuleContext, widget, [rule, null], { rule: rule, widget: widget });
    var offerTitle = call(module.getTitle, module, [ctx], rule.name || '') || rule.name || '';
    var card = {
      id: rule.id,
      title: TITLE_BY_RULE_ID[rule.id] || '',
      description: buildDescription(widget, rule),
      url: URL_BY_RULE_ID[rule.id] || call(module.getRuleUrl, module, [rule, ctx], ''),
      gifts: []
    };

    return getRuleGifts(module, rule).then(function (gifts) {
      return Promise.all(gifts.map(function (gift) { return resolveGift(module, ctx, gift); }));
    }).then(function (gifts) {
      card.gifts = gifts.filter(function (g) { return g.title || g.image; });
      if (IMAGE_BY_RULE_ID[rule.id]) card.gifts.unshift({ title: card.title || offerTitle, image: normalizeUrl(IMAGE_BY_RULE_ID[rule.id]) });
      if (!card.title) card.title = joinGiftTitles(card.gifts.map(function (g) { return g.title; })) || offerTitle;
      return card;
    });
  }

  /* ---------- Giao diện ---------- */
  var root, list, badge;

  function skeletonHTML(count) {
    var card =
      '<div class="bss-offer-card">' +
        '<div class="bss-offer-thumb"><div class="bss-skel bss-skel-img"></div></div>' +
        '<div class="bss-offer-body" style="width:100%">' +
          '<div class="bss-skel bss-skel-line"></div>' +
          '<div class="bss-skel bss-skel-line bss-skel-line--short"></div>' +
          '<div class="bss-skel bss-skel-btn"></div>' +
        '</div>' +
      '</div>';
    return new Array(Math.max(1, Math.min(count, 3)) + 1).join(card);
  }

  function cardHTML(o) {
    var withImage = o.gifts.filter(function (g) { return g.image; });
    var main = withImage[0];
    var thumb = main
      ? '<img class="bss-offer-main" src="' + esc(main.image) + '" alt="' + esc(main.title) + '">'
      : '<div class="bss-offer-thumb-empty">' + tagSvg + '</div>';
    // Nhiều quà: dải ảnh nhỏ bên dưới, bấm để xem ảnh từng quà
    if (withImage.length > 1) {
      thumb += '<div class="bss-offer-minis">' + withImage.map(function (g, i) {
        return '<button type="button" class="bss-offer-mini" title="' + esc(g.title) + '" aria-label="' + esc(g.title) + '"' +
          ' aria-pressed="' + (i === 0) + '" data-src="' + esc(g.image) + '">' +
          '<img src="' + esc(g.image) + '" alt="">' +
        '</button>';
      }).join('') + '</div>';
    }
    var btn = o.url
      ? '<a class="bss-offer-btn" href="' + esc(o.url) + '">' + esc(TEXT.button) + '</a>'
      : '<button type="button" class="bss-offer-btn" data-bss-view="' + esc(o.id) + '">' + esc(TEXT.button) + '</button>';
    return (
      '<div class="bss-offer-card">' +
        '<div class="bss-offer-thumb">' + thumb + '</div>' +
        '<div class="bss-offer-body">' +
          '<p class="bss-offer-title">' + esc(o.title) + '</p>' +
          (o.description ? '<p class="bss-offer-desc">' + esc(o.description) + '</p>' : '') +
          btn +
        '</div>' +
      '</div>'
    );
  }

  function build() {
    root = document.createElement('div');
    root.id = 'bss-offer-root';
    root.innerHTML =
      '<div class="bss-offer-panel" role="dialog" aria-label="' + esc(TEXT.title) + '">' +
        '<div class="bss-offer-head">' +
          '<p class="bss-offer-head-title">' + esc(TEXT.title) + '</p>' +
          (TEXT.subtitle ? '<p class="bss-offer-head-sub">' + esc(TEXT.subtitle) + '</p>' : '') +
          '<button type="button" class="bss-offer-close" aria-label="' + esc(TEXT.close) + '">' + closeSvg + '</button>' +
        '</div>' +
        '<div class="bss-offer-list"></div>' +
      '</div>' +
      '<button type="button" class="bss-offer-launcher" aria-expanded="false">' +
        giftSvg + '<span>' + esc(TEXT.launcher) + '</span><span class="bss-offer-badge"></span>' +
      '</button>';
    document.body.appendChild(root);
    list = root.querySelector('.bss-offer-list');
    badge = root.querySelector('.bss-offer-badge');
    var btn = root.querySelector('.bss-offer-launcher');

    function toggle(open) {
      var isOpen = typeof open === 'boolean' ? open : !root.classList.contains('is-open');
      root.classList.toggle('is-open', isOpen);
      btn.setAttribute('aria-expanded', isOpen);
    }
    btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    root.querySelector('.bss-offer-close').addEventListener('click', function (e) { e.stopPropagation(); toggle(false); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) toggle(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggle(false); });

    list.addEventListener('click', function (e) {
      // Ảnh nhỏ -> đổi ảnh lớn của thẻ
      var mini = e.target.closest('.bss-offer-mini');
      if (mini) {
        var thumbBox = mini.closest('.bss-offer-thumb');
        var mainImg = thumbBox.querySelector('.bss-offer-main');
        if (mainImg) {
          mainImg.src = mini.getAttribute('data-src');
          mainImg.alt = mini.getAttribute('aria-label') || '';
        }
        thumbBox.querySelectorAll('.bss-offer-mini').forEach(function (m) { m.setAttribute('aria-pressed', String(m === mini)); });
        return;
      }
      // Offer không có URL -> dùng hành vi "View this offer" gốc của app
      var b = e.target.closest('[data-bss-view]');
      if (!b) return;
      e.preventDefault();
      var m = window.tlFreeGiftOffer && window.tlFreeGiftOffer.todayOfferModule;
      call(m && m.handleViewOfferById, m, [b.getAttribute('data-bss-view')]);
    });
  }

  var renderToken = 0;
  function render(widget) {
    try {
      var rules = call(widget.getSortedDisplayRules, widget, [], []) || [];
      if (!root) build();
      badge.textContent = rules.length;
      root.classList.toggle('is-ready', rules.length > 0);
      document.documentElement.classList.toggle('bss-offer-on', rules.length > 0);
      if (!rules.length) { list.innerHTML = ''; return; }

      var token = ++renderToken;
      if (!list.children.length) list.innerHTML = skeletonHTML(rules.length);

      Promise.all(rules.map(function (rule) { return getOfferCard(widget, rule); })).then(function (cards) {
        if (token !== renderToken) return;
        list.innerHTML = cards.map(cardHTML).join('');
        badge.textContent = cards.length;
      }).catch(function (err) {
        console.error('[BSS Today Offer] render error:', err);
      });
    } catch (err) {
      // Lỗi -> trả lại tab Today Offers gốc
      console.error('[BSS Today Offer] render error:', err);
      document.documentElement.classList.remove('bss-offer-on');
      if (root) root.classList.remove('is-ready');
    }
  }

  // Bọc updateOffer: cập nhật lại khi app cập nhật offer (ví dụ sau Add to cart)
  function hook(widget) {
    if (widget.__bssLauncherHooked) return;
    widget.__bssLauncherHooked = true;
    var original = widget.updateOffer;
    widget.updateOffer = function () {
      var result;
      try { result = original.apply(this, arguments); } catch (e) { console.error('[BSS Today Offer] app updateOffer error:', e); }
      render(widget);
      return result;
    };
    render(widget);
  }

  function tryHook() {
    var widget = getWidget();
    if (widget && typeof widget.updateOffer === 'function' && document.body) {
      hook(widget);
      return true;
    }
    return false;
  }

  /* ---------- Gift in cart: "1 offer" / "2 offers" ---------- */
  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Giữ kiểu chữ của bản gốc (OFFERS / Offers / offers)
  function matchCase(word, sample) {
    if (sample === sample.toUpperCase()) return word.toUpperCase();
    if (sample[0] === sample[0].toUpperCase()) return word[0].toUpperCase() + word.slice(1);
    return word;
  }

  function pluralizeOfferNumber(text) {
    var m = String(text).match(/\d+/);
    if (!m) return text;
    var isOne = Number(m[0]) === 1;
    GIC_PLURALS.forEach(function (p) {
      // "offer(s)" hoặc số ít/số nhiều đứng sau con số
      var re = new RegExp('(' + escapeRegExp(p.other) + '|' + escapeRegExp(p.one) + ')(\\(s\\))?', 'i');
      text = text.replace(re, function (found, word) {
        return matchCase(isOne ? p.one : p.other, word);
      });
    });
    return text;
  }

  function fixGicOfferNumbers() {
    var els = document.querySelectorAll('.salepify-gic__offer-number');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var next = pluralizeOfferNumber(el.textContent);
      if (next !== el.textContent) el.textContent = next;
    }
  }

  var gicScheduled = false;
  function scheduleGicFix() {
    if (gicScheduled) return;
    gicScheduled = true;
    requestAnimationFrame(function () { gicScheduled = false; fixGicOfferNumbers(); });
  }

  function start() {
    injectStyle();

    // Gift in cart viết lại số offer mỗi lần cart đổi -> sửa lại mỗi khi DOM đổi
    new MutationObserver(scheduleGicFix).observe(document.body, { childList: true, subtree: true, characterData: true });
    scheduleGicFix();

    window.addEventListener('salepify:today-offer-ready', tryHook);
    if (tryHook()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (tryHook()) return clearInterval(timer);
      if (++tries > 120) {
        clearInterval(timer);
        console.warn('[BSS Today Offer] Không tìm thấy window.SalepifyTodayOffer.widget');
      }
    }, 500);
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();

// custom GIC
(function () {
  try {
    if (window.__tlGicLinkedProductLoaded) return;
    window.__tlGicLinkedProductLoaded = true;

    // Gift in Cart: only show an offer when the cart contains a product linked to that offer
    // (the offer's "Customer buy" products / variants / collections / tag).
    // If no offer is left, the app hides the whole Gift in Cart widget.
    var WAIT_TIMEOUT = 20000;

    // ruleKey -> true if the cart has a linked product
    var linkedByRuleKey = new Map();

    function isFreeGiftOffer(gic, offer) {
      var M = gic.MODULE || {};
      return [M.FREE_GIFT, M.BOGO, M.EMBED, M.POPUP].indexOf(offer.module) !== -1;
    }

    async function hasLinkedProduct(fg, offer) {
      try {
        var checkApplyTo = fg.makeApplyToChecker(offer);
        var items = fg.getItems(offer);
        for (var i = 0; i < items.length; i++) {
          var itemData = items[i][1];
          if (!itemData || !itemData.quantity) continue;
          if (offer.purchase_type && !fg.checkPurchaseType(itemData, offer.purchase_type)) continue;
          if (await checkApplyTo(itemData)) return true;
        }
        return false;
      } catch (e) {
        console.warn('[tl-gic-linked] check offer error', offer && offer.id, e);
        return true; // on error keep app behavior (show the offer)
      }
    }

    async function refreshLinkedState(gic, fg) {
      try {
        var offers = gic.offers || [];
        for (var i = 0; i < offers.length; i++) {
          var offer = offers[i];
          if (!isFreeGiftOffer(gic, offer)) continue;
          var ruleKey = gic.utils.getRuleKey(offer.id, offer.module);
          linkedByRuleKey.set(ruleKey, await hasLinkedProduct(fg, offer));
        }
      } catch (e) {
        console.warn('[tl-gic-linked] refresh error', e);
      }
    }

    function patch(gic, fg) {
      if (gic.__tlLinkedPatched) return;
      gic.__tlLinkedPatched = true;

      var originalGetOfferState = gic.getOfferState;
      gic.getOfferState = function (offerId, offerModule) {
        var state = originalGetOfferState.apply(this, arguments);
        try {
          var ruleKey = this.utils.getRuleKey(offerId, offerModule);
          // "isStopped" makes the app hide the card, close its gift selector and exclude it from the offer count
          if (linkedByRuleKey.get(ruleKey) === false) state = Object.assign({}, state, { isStopped: true });
        } catch (e) {
          console.warn('[tl-gic-linked] getOfferState error', e);
        }
        return state;
      };

      // Every UI refresh (cart change, drawer open, claim...) goes through updateAllOfferCardsUI
      var originalUpdateAll = gic.updateAllOfferCardsUI;
      gic.updateAllOfferCardsUI = async function () {
        await refreshLinkedState(this, fg);
        return originalUpdateAll.apply(this, arguments);
      };

      // Re-render in case the widget already rendered before the patch
      gic.updateAllOfferCardsUI().catch(function (e) {
        console.warn('[tl-gic-linked] update error', e);
      });
    }

    var startedAt = Date.now();
    var timer = setInterval(function () {
      try {
        var gic = window.tlGiftInCartWidget;
        var fg = window.tlFreeGiftOffer;
        if (gic && fg && typeof gic.getOfferState === 'function' && typeof fg.makeApplyToChecker === 'function') {
          clearInterval(timer);
          patch(gic, fg);
        } else if (Date.now() - startedAt > WAIT_TIMEOUT) {
          clearInterval(timer);
        }
      } catch (e) {
        clearInterval(timer);
        console.warn('[tl-gic-linked] init error', e);
      }
    }, 100);
  } catch (e) {
    console.warn('[tl-gic-linked] init error', e);
  }
})();


